import React from 'react';
import { observer } from 'mobx-react-lite';
import { DefaultQueryParams, isMobile, parseQuery } from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { Timer } from '../timer';
import { BetHelper } from '../betHelper';
import { BurningCards } from '../burningCards';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE } from '../../enums/cardTypes';
import { turboGameService } from '../../services/TurboGameService';
import { gameStore } from '../../store/gameStore';
import { TURBO_GAME_ID } from '../../enums/constants';

export const RoundInfo = observer(() => {
  const { burnedCards, isCuttingCardOpen, selectedCardBackSideType, burnedCardsCount } = cardsStore;
  const { isBetsClosed } = gameStore;
  const { isShuffle } = cardsStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  return (
    <div className={`place-bets-cont ${isTurbo ? 'turbo' : ''}`}>
      {isTurbo && !isBetsClosed && !isShuffle && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button
          className='shuffle-btn'
          type='button'
          onClick={() => turboGameService.sendShuffleCards()}
        >
          <span className='icon-shuffle-icon' />
        </button>
      )}
      {burnedCards.length ? (
        <div className='place-bets-card'>
          <div className='cards bets-card'>
            <div className={`card-holder ${CARDS_TYPE[burnedCards[0]?.card]}`}>
              <div className='card-holder-inner' />
            </div>
          </div>
        </div>
      ) : null}
      {isMobile() ? null : <Timer />}
      <BetHelper />
      {burnedCards.length || isCuttingCardOpen ? (
        <BurningCards
          selectedCardBackSideType={selectedCardBackSideType}
          burnedCards={burnedCards}
          burnedCardsCount={burnedCardsCount}
          isCuttingCardOpen={isCuttingCardOpen}
        />
      ) : null}
    </div>
  );
});
